import { useMemo } from "react";

import type { ExistingOptionI18nQuery } from "@/lib/gql/__generated__/graphql";

import { useInitProductOptionI18nFormModelContext } from "../../../init";
import { serverModelToInputModelConverter } from "./converter/server-model-to-input-mode/server-model-to-input-mode";
import { useOptionI18nEditMutation } from "../../../repository/existing";

import type { ProductExistingOptionI18nFormModelContextType } from "../../../../ui/existing/context/context";
import type { QueryData } from "../../../type";

type Props = {
	serverModel: ExistingOptionI18nQuery;
};

export const useInitialized = ({ serverModel }: Props): ProductExistingOptionI18nFormModelContextType => {
	const inputModel = useMemo(() => serverModelToInputModelConverter(serverModel), [serverModel]);

	const queryData = undefined satisfies QueryData;

	const { onSetViewModel, viewModel, resetViewModel } = useInitProductOptionI18nFormModelContext({
		inputModel,
		queryData,
	});

	const { onUpdate } = useOptionI18nEditMutation({ resetForm: resetViewModel });

	return {
		queryData,
		onSetViewModel,
		viewModel,
		onUpdate: () => onUpdate({ ...viewModel }),
	};
};
